import { Box, Fab} from "@mui/material";
import React from "react";
import DynamicTable from "../../../../data/DynamicTable/dynamicTable";
import { caseManagementUrl } from "../../../../config";
import FileProgressForm from "./FileProgressForm";
import { format } from "date-fns";
import { DataObject } from "@mui/icons-material";
import { useNavigate, useLocation } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

// Define columns BEFORE the component for best practice
export const AllActivitiesColumns = [
  {
    field: "fileNo",
    headerName: "File No",
    flex: 2,
  },
  {
    field: "clientName",
    headerName: "Client Name",
    flex: 2,
    valueGetter: (params) =>
    params.row.clientName ||
    params.row.clientName ||
    params.row.createdByUsername ||
    "-" 
  },
  {
    field: "caseTitle",
    headerName: "Case Title",
    flex: 2,
  },
  {
    field: "activityType",
    headerName: "Case Activity Type",
    flex: 2,
  },
  {
    field: "actionDate",
    headerName: "Date",
    flex: 2,
    valueGetter: (params) => {
      const value = params.row?.actionDate;
      if (!value) return "-"; 

      const date = new Date(value);
      if (isNaN(date)) return "-"; 

      return date.toISOString().split("T")[0]; // format YYYY-MM-DD
    },
  },

 {
    field: "dynamicProgressBringup",
    headerName: "Details / Outcome",
    flex: 3,
    renderCell: (params) => {
      const { activityType } = params.row;

      const activityTypeMapping = {
        "Court Attendance": { field: "outcome", defaultText: "No outcome recorded" },
        "File Bring Up": { field: "nextStep", defaultText: "No remarks" },
        "File Progress & Bring Up": { field: "nextStep", defaultText: "No remarks" },
        "Book Court Date": { field: "remarks", defaultText: "No remarks" }, // 👈 added for Book Court Date
      };

      const mapping = activityTypeMapping[activityType] || {
        field: "actionTaken",
        defaultText: "No description",
      };

      return params.row[mapping.field] || mapping.defaultText;
    },
  },

  {
    field: "courtName",
    headerName: "Court / Next Step",
    flex: 2,
    valueGetter: (params) => {
    const { activityType, courtName, nextStep } = params.row || {};

    if (
      activityType === "Court Attendance" ||
      activityType === "Book Court Date"
    ) {
      return courtName ?? "–";
    }

    return nextStep ?? "–";
  },
  },

  // ✅ Clean next bring-up date rendering
  {
    field: "nextBringUpDate",
    headerName: "Next Bring Up",
    flex: 1,
    valueGetter: (params) => {
      const value = params.row?.nextBringUpDate;
      if (!value) return "-"; 

      const date = new Date(value);
      if (isNaN(date)) return "-"; 

      return date.toISOString().split("T")[0]; // format YYYY-MM-DD
    },
  },
];
function CaseEvents() {
  const base_url = caseManagementUrl.uri;

  const location = useLocation();

  const navigate = useNavigate();

  const caseId = 
    location.state?.caseId ||
    JSON.parse(localStorage.getItem("CaseId"));

  const handleGoBack = () => {
    const backPath = location.state?.from || "/Cases";
    navigate(backPath);
  };

  const actions = {
    entity: "File Progress And Bringup",
    isSubRight: true,
    edit: {
      key: "EDIT",
      button_name: "Edit",
      Show_Button: true,
      permission: "EditPermission",
    },
    add: {
      key: "ADD",
      button_name: "Add",
      Show_Button: true,
      permission: "CreatePermission",
    },
    activateDeactivate: {
      key: "ACTIVATEDEACTIVATE",
      button_name: "Deactivate",
      Show_Button: false,
      permission: "ActivatePermission",
    },
    showStatus: true,
    dataObject: {
      inputObjectName: "allCaseActivitiesByColumnValues",
      inputSubObjectName: "casesViewModel",
      inputFields: {
        fileId: caseId,
      },
      returnFields: [
        "id",
        "fileId",
        "caseTitle",
        "fileNo",
        "clientName",
        "activityType",
        "actionTypeName",
        "actionTaken",
        "actionDate",
        "remarks",
        "nextStep",
        "nextBringUpDate",
        "status",
        "courtName",
        "caseNumber",
        "judgeName",
        "outcome",
        "timeTaken",
        "appearanceType",
        "advocateName",
        "nextOption",
        "nextOptionDate",
        "nextAction",
        "nextActionReminderPeriod",
        "purposeOfAttendance",
        "advocatePresent",
        "courtDate",
        "petitioner",
        "defendant",
        "courtId"
      ],
    },
  };

  return (
    <Box m="2px" p= "1rem">
      {/* Floating Back Button */}
      <Fab
        color="secondary"
        aria-label="go back"
        onClick={handleGoBack}
        sx={{
          position: "fixed",
          top: 160,      
          left: 290,     
          zIndex: 1100,
          width: 40,
          height: 40,
          boxShadow: 3,
          "&:hover": {
            boxShadow: 6,
          },
        }}
      >
        <ArrowBackIcon />
      </Fab>

      <DynamicTable
        title="File Progress & Bring Ups"
        subtitle="View and manage all file activities, reminders, and court attendances"
        columns={AllActivitiesColumns}
        FormComponent={FileProgressForm}
        base_url={base_url}
        actions={actions}
      />
    </Box>
  );
}

export default CaseEvents;
